import styled from "styled-components";

export const Container = styled.div`
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  gap: 0px 0px;
  grid-template-areas:
    ". ."
    ". ."
    ". .";
  overflow: hidden;
  .extra-div {
    display: none;
  }
  .delete-position-popup {
    z-index: 2;
    position: absolute;
    display: flex;
    height: 30vh;
    transform: rotate(90deg);
    width: 70vw;
    max-width: 900px;
    max-height: 500px;
    left: 15vw;
    top: 30vh;
    padding: 1% 2%;
    background-color: #fff;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 45px;
  }
  @media only screen and (min-width: 867px) {
    height: calc(100vh - 50px);
    grid-template-columns: 5% auto 80px;
    display: grid;
    grid-template-rows: calc(90vh - 50px) 10vh;
    gap: 0px 0px;
    grid-template-areas:
      ". ."
      ". .";
    &.open {
      grid-template-columns: 5% auto 30%;
    }
    .extra-div {
      display: block;
    }
    .delete-position-popup {
      transform: rotate(0deg);
      width: 30vw;
      left: 35vw;
    }
  }
`;
export const Court = styled.div`
  display: flex;
  background: url("/assets/court-backgorund.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  .court-img {
    display: none;
  }
  .court-img-m {
    width: 100%;
    transform: rotate(180deg);
  }
  @media only screen and (min-width: 867px) {
    height: 100%;
    .court-img-m {
      display: none;
    }
    .court-img {
      display: block;
      width: 100%;
    }
  }
`;

export const Navbar = styled.nav`
  width: 100%;
  height: 80px;
  display: grid;
  align-items: center;
  background-color: #2a2a2a;
  justify-content: end;
  color: #fff;
  grid-template-rows: 50% 50%;
  grid-template-columns: 21% 21% 21% 15%;
  grid-template-areas:
    "object1 object2 object3 backArrow"
    "object4 object5 object6 saveButton";
  div {
    height: fit-content;
    display: flex;
    align-items: center;
    width: 80%;
    height: 100%;
    padding: 0 2%;
    img {
      width: 50%;
      margin-left: 3%;
    }
    a {
      width: 100%;
      img {
        display: flex;
        width: 50%;
        margin-left: 15%;
        transform: rotate(90deg);
      }
    }
    h1 {
      display: none;
    }
    p {
      margin: 0;
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    grid-area: object3;
    transform: rotate(90deg);
    margin-left: auto;
    cursor: not-allowed;
    padding: 0;
    width: 100%;
    opacity: 0.5;
    &.is-edit {
      opacity: 1;
      cursor: pointer;
    }
    img {
      width: fit-content;
      width: 50%;
      padding: 0 0.5rem;
    }
    p {
      display: none;
    }
  }
  .saveButton {
    grid-area: object6;
    transform: rotate(90deg);
    width: 100%;
    cursor: pointer;
    img {
      width: 30%;
      padding: 0 0.5rem;
      margin: auto;
    }
    p {
      display: none;
    }
  }
  .back-arrow-m {
    grid-area: backArrow;
    cursor: pointer;
  }
  .own-player-m {
    grid-area: object2;
  }
  .rival-player-m {
    grid-area: object5;
  }
  .ball-m {
    grid-area: object1;
  }
  @media only screen and (min-width: 867px) {
    height: 50px;
    align-items: center;
    align-items: center;
    display: flex;
    justify-content: space-between;
    div {
      width: auto;
      a {
        width: 70%;
        img {
          width: 70%;
          transform: inherit;
          display: flex;
          margin-left: 15%;
        }
      }
      h1 {
        display: flex;
        margin: 0;
        font-size: 20px;
      }
    }
    .buttons {
      display: flex;
      justify-content: flex-end;
      grid-area: unset;
      transform: inherit;
      img {
        width: 20%;
      }
      p {
        display: block;
      }
    }
    .saveButton {
      transform: rotate(0deg);
      width: auto;
      p {
        display: block;
      }
    }
    .own-player-m,
    .rival-player-m,
    .ball-m {
      display: none;
    }
    .back-arrow-m {
      grid-area: unset;
      width: 10%;
    }
  }
`;

export const SectorNav = styled.div`
  display: flex;
  flex-direction: row;
  width: 20%;
  .edit-icon {
    width: 30px !important;
  }
  a {
    width: 100%;
    height: 100%;
  }
  p {
    width: auto;
    height: fit-content;
    margin: 0;
  }
`;
export const Sidebar = styled.div`
  background-color: #2a2a2a;
  width: 100%;
  height: auto;
  padding: 0 3% 0 3%;
  display: none;
  flex-direction: column;
  align-items: center;
  div {
    width: 100%;
    height: 10%;
    border: 2px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: white;
      img {
        filter: invert(100%);
        width: 75%;
      }
    }
  }
  img {
    width: fit-content;
    height: fit-content;
    margin: 5% 0;
  }
  h1 {
    color: #ccc;
    font-size: 20px;
    font-family: "Comic Neue Bold";
  }
  p {
    color: #fff;
    font-size: 16px;
    font-family: "Comic Neue Bold";
  }
  @media only screen and (min-width: 867px) {
    display: flex;
  }
`;
export const RedDot = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50px;
  background-color: #c4342c;
  color: #fff;
  font-size: 20px;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  p {
    transform: rotate(90deg);
  }
  @media only screen and (min-width: 867px) {
    height: 50px;
    width: 50px;
    p {
      transform: rotate(0deg);
    }
  }
`;
export const BlueDot = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50px;
  background-color: blue;
  color: #fff;
  font-size: 20px;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  p {
    transform: rotate(90deg);
  }
  @media only screen and (min-width: 867px) {
    height: 50px;
    width: 50px;
    p {
      transform: rotate(0deg);
    }
  }
`;
export const BallDot = styled.div`
  position: absolute;
  height: 35px;
  width: 35px;
  border-radius: 50px;
  color: #fff;
  font-size: 20px;
  z-index: 5;
  text-align: center;
  background: url("/assets/Ball.png");
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  @media only screen and (min-width: 867px) {
    height: 50px;
    width: 50px;
  }
`;
export const AnimatorBar = styled.div`
  display: grid;
  grid-template-columns: 12% 8% 8% 8% 8% auto 20% 8%;
  color: #fff;
  background-color: black;
  text-align: center;
  height: calc(20% - 4px);
  #positions-container {
    width: 100%;
    overflow: scroll;
    background-color: transparent;
    display: flex;
    justify-content: flex-start;
    &::-webkit-scrollbar {
      display: none;
    }
    .positionNumber {
      width: 50px;
      max-width: 50px;
      min-width: 50px;
      height: 100%;
      background-color: #2a2a2a;
      margin: 0 1px 0 1px;
      text-align: center;
      cursor: pointer;
      img {
        width: 60%;
        margin: auto;
        z-index: 10;
      }
    }
    .inactive {
      opacity: 0.5;
    }
    .active {
      opacity: 1;
      background: #ff6a00;
    }
    img {
      width: 60%;
    }
  }
  .lastContainers {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 70%;
    }
    p {
      font-size: 16px;
    }
    &.unactive {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotate(90deg);
  }
  .loop-active {
    border: 2px solid green;
    opacity: 1;
  }
  .loop-unactive {
    background-color: #2a2a2a;
    opacity: 0.5;
  }
  @media only screen and (min-width: 867px) {
    height: 100%;
    grid-template-columns: 8% 4% 4% 4% 4% auto 20% 4%;
    grid-column-start: 2;
    grid-column-end: 4;
    .disclaimer {
      justify-content: flex-end;
    }
    p {
      transform: inherit;
    }
  }
`;
export const AnimatorBarContainer = styled.div`
  width: 90%;
  height: calc(100% - 4px);
  background-color: #2a2a2a;
  margin: 0 1px 0 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid black;
  cursor: pointer;
  &:hover {
    background: white;
    img {
      width: 75%;
    }
  }
  &#positions-container {
    cursor: unset;
  }

  img {
    width: 60%;
    transform: rotate(90deg);
  }
  @media only screen and (min-width: 867px) {
    img {
      transform: inherit;
    }
  }
`;
export const PositionNumber = styled.div`
  width: 50px;
  min-width: 50px;
  height: calc(100% - 4px);
  background-color: #2a2a2a;
  margin: 0 1px 0 1px;
`;
export const Square = styled.div`
  width: 100px;
  height: 100px;
  border: 2px solid red;
  overflow: auto;
  //resize: both;
  .tr-transform__rotator:hover,
  .tr-transform__scale-point:hover {
    background: #f1f5f8;
  }
  .tr-transform__rotator:active,
  .tr-transform__scale-point:active {
    background: #dae1e7;
  }
  .tr-transform__scale-point {
  }

  .tr-transform__scale-point--tl {
    top: -7px;
    left: -7px;
  }

  .tr-transform__scale-point--ml {
    top: calc(50% - 7px);
    left: -7px;
  }

  .tr-transform__scale-point--tr {
    left: calc(100% - 7px);
    top: -7px;
  }

  .tr-transform__scale-point--tm {
    left: calc(50% - 7px);
    top: -7px;
  }

  .tr-transform__scale-point--mr {
    left: calc(100% - 7px);
    top: calc(50% - 7px);
  }

  .tr-transform__scale-point--bl {
    left: -7px;
    top: calc(100% - 7px);
  }

  .tr-transform__scale-point--bm {
    left: calc(50% - 7px);
    top: calc(100% - 7px);
  }

  .tr-transform__scale-point--br {
    background: #fff;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
    left: calc(100% - 7px);
    top: calc(100% - 7px);
  }
`;
